import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const CloseButton = ({
  color,
  backgroundColor,
  onHoverColor,
  onClick,
  cyData,
}) => {
  const StyledCloseButton = styled.div`
    position: absolute;
    top: 16px;
    right: 16px;
    background-color: ${backgroundColor};
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: min(40px, 10vw);
    height: min(40px, 10vw);
    transition: background-color 200ms ease;
    z-index: 4;

    &:hover {
      cursor: pointer;
      background-color: ${onHoverColor};

      .cros {
        transform: scale(110%);
      }
    }

    .cros {
      transition: transform 200ms ease;
      position: relative;

      .one,
      .two {
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 16px;
        height: 2px;
        background-color: ${color};
      }
    }
    .one {
      transform: translate(-50%, -50%) rotate(45deg);
    }
    .two {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  `;

  return (
    <StyledCloseButton
      data-cy={cyData}
      className="close-container"
      onClick={onClick}
    >
      <div className="cros">
        <span className="one"></span>
        <span className="two"></span>
      </div>
    </StyledCloseButton>
  );
};

CloseButton.propTypes = {
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  onHoverColor: PropTypes.string,
};

CloseButton.defaultProps = {
  color: "blue",
  backgroundColor: "transparent",
  onHoverColor: "grey1",
};

export default CloseButton;
